<template>
    <div :id="id" class="row">
      <LmTextInput
        ref="inputFocus"
        :id="id + 'label'"
        class="col-12 col-md-4"
        v-model="component.componentProps.label"
        @input="onLabelChange($event)"
        :label="$t('title')"
        :placeholder="$t('title')"
        :help="$t('comp_title_help')"
      />
      <LmTextInput
        v-if="validateSuperUser"
        class="col-12 col-md-4"
        :id="id + 'nombre'"
        v-model="component.formObjectToSendToServerProperty"
        @input="$emit('input', component); $emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
        :label="$t('name')"
        :placeholder="$t('name')"
        :help="$t('comp_name_help')"
      />
      <LmSelect
        :id="id + 'css'"
        class="col-12 col-md-4"
        v-model="component.class"
        :options="{
          content: [
            {value: 'col-12 col-md-3',text: '25%'},
            {value: 'col-12 col-md-6', text: '50%'},
            {value: 'col-12 col-md-9', text: '75%'},
            {value: 'col-12 col-md-12', text: '100%'}
          ]
        }"
        :label="$t('desktop_view_width')"
        :help="$t('help_width_form_element')"
        @input="$emit('input', component)"
      />
      <LmColorPicker
        class="col-auto"
        :label="$t('color_picker_label')"
        :id="id ? id + '-default-color' : 'default-color'"
        @input="onInputColorPicker($event)"
        />
      <hr class="w-100 mx-2">
      <div class="col-12">
        <h5>{{ $t('validations') }}</h5>
        <div class="row align-items-center">
          <LmCheckbox
            class="col-12 col-md-4"
            :labelSingle="$t('required')"
            v-model="validations.required"
            @input="$emit('validations-changes', {[component.formObjectToSendToServerProperty]:validations})"
          />
          <LmSelect
            v-if="component.componentName !== 'LmEditor'"
            :id="id + 'same-as'"
            class="col-12 col-md-4"
            v-model="validations.sameAs"
            :options="optionsSameAsValidation"
            :label="$t('value_has_to_be_equal_to')"
            @input="onInputValidationSameAs(optionsSameAsValidation.content.find(e => e.value === validations.sameAs))"
          />
        </div>
      </div>
      <hr class="w-100 mx-2">
      <LmConditionalBuilderUi
        v-if="isVisibleCondition"
        class="col-12"
        :id="id"
        :leftValueToCompareOptions="leftValueToCompareOptions"
        :visibilityDependOnConditions="visibilityDependOnConditions"
        @changeVisibilityDependOnConditions="component.visibilityDependOnConditions = $event"
        @input="$emit('input', component)"
        />
    </div>
</template>

<script>
import lmFormElementsBuilderUiMixin from '@/mixins/lmFormElementsBuilderUiMixin.js'
import LmColorPicker from '@/components/form/elements/LmColorPicker'

export default {
  mixins: [lmFormElementsBuilderUiMixin],
  data () {
    return {
      validations: {
        required: false,
        sameAs: ''
      }
    }
  },
  methods: {
    onInputColorPicker (event) {
      this.component.componentProps.defaultValue = event
      this.$emit('input', this.component)
    }
  },
  components: {
    LmColorPicker
  },
  watch: {
    componentData () {
      this.component = this.componentData
    }
  },
  props: {
    isVisibleCondition: {
      type: Boolean,
      default: true
    }
  }
}
</script>
